import styled from 'styled-components';
import { Space, Tag } from 'antd';
import { ButtonWrapper, ButtonLabel } from '@src/styles/styled/mixins';

export const StyledTrendSelector = styled.div`
  ${ButtonWrapper}
  padding-top: 5px 0;
`;

export const StyledTrendLabel = styled.span`
  ${ButtonLabel}
`;

export const StyledToggleWrapper = styled.div`
  width: 60px;
  margin: 5px;
`;

export const KebabWrapper = styled.div`
  line-height: 2;
`;

export const MetricTagsWrapper = styled.div`
  overflow: hidden;
  flex: 1;
  display: flex;
`;

export const TagWrapper = styled.div`
  display: flex;
  overflow: auto;
  flex: 1;
  gap: 5px;
  padding: 2px 0;
  flex-wrap: wrap;
`;

export const StyledTag = styled(Tag)<{
  $disableMode?: boolean;
}>`
  font-size: 12px;
  padding: 3px 5px;
  margin: 0;
  cursor: ${(props) => (props.$disableMode ? 'not-allowed' : 'pointer')};
  background-color: #f5f5f5;
  align-self: center;
  position: relative;

  .anticon {
    font-size: 12px;
  }
`;

export const StyledResizeLabel = styled.div`
  margin-bottom: 8px;
  color: rgb(0 0 0 / 88%);
  font-weight: 600;
`;

export const MiddleSpace = styled(Space)`
  padding: 0 10px;
  border-right: 1px solid #e9edf0;
  border-left: 1px solid #e9edf0;
`;

export const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  > div {
    padding: 5px 0;
  }
`;
